"use client";

import type { ReactNode } from "react";
import type * as z from "zod";
import React, { createContext, useContext, useState } from "react";

import type { AddToCalendarCardProps } from "~/components/AddToCalendarCard";
import type { organizeFormSchema } from "~/components/YourDetails";

type OrganizeData = Omit<z.infer<typeof organizeFormSchema>, "visibility"> & {
  visibility?: z.infer<typeof organizeFormSchema>["visibility"];
};

interface NewEventContextState {
  organizeData: OrganizeData;
  setOrganizeData: (data: OrganizeData) => void;
  eventData?: AddToCalendarCardProps;
  setEventData: (data?: AddToCalendarCardProps) => void;
}

const NewEventContext = createContext<NewEventContextState>({
  organizeData: {
    notes: "",
    lists: [],
  },
  setOrganizeData: () => null,
  eventData: undefined,
  setEventData: () => null,
});

export const useNewEventContext = () => useContext(NewEventContext);

export const NewEventProvider = ({ children }: { children: ReactNode }) => {
  const [organizeData, setOrganizeData] = useState<
    NewEventContextState["organizeData"]
  >({
    notes: "",
    lists: [],
  });
  const [eventData, setEventData] =
    useState<NewEventContextState["eventData"]>(undefined);

  return (
    <NewEventContext.Provider
      value={{
        organizeData,
        setOrganizeData,
        eventData,
        setEventData,
      }}
    >
      {children}
    </NewEventContext.Provider>
  );
};
